import Model from "../Model.js";

/**
 * `abstractSpecification` is an abstract class
 * representing a specification.
 *
 * It exposes a Visitor Pattern `accept` function
 * to allow concrete implementations of `specificationVisitor`
 * to traverse the whole tree forming a specification.
 *
 * @abstract
 */
export default class AbstractSpecification extends Model {
	leaves() {
		return [this];
	}

	/**
	 * Accept function of a Visitor Pattern.
	 * Used to dispatch the behavior based on the
	 * specification type.
	 */
	accept(visitor) {
		return visitor.visitAbstractSpecification(this);
	}

	isLeaf() {
		return false;
	}

	isAnd() {
		return false;
	}

	isOr() {
		return false;
	}

	isNot() {
		return false;
	}

	isAccountIntervalSpecification() {
		return false;
	}

	getAccountIntervals() {
		return this.leaves()
			.filter((leaf) => leaf.isAccountIntervalSpecification())
			.map((leaf) => leaf.getInterval());
	}

	_serializedProperties() {
		const properties = super._serializedProperties();

		properties.type = this.constructor.getType();

		return properties;
	}

	static getType() {
		this._subclassResponsibility();
	}
}
